import { render, staticRenderFns } from "./BoingSolid.vue?vue&type=template&id=479b1180&scoped=true"
import script from "./BoingSolid.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoingSolid.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BoingSolid.vue?vue&type=style&index=0&id=479b1180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b1180",
  null
  
)

export default component.exports